module.exports = __webpack_public_path__ + "static/media/kayahara_spinner.9a780af8.gif";